import {
    GET_INBOX_START,
    GET_INBOX_SUCCESS,
    GET_INBOX_FAIL,
    GET_CONVERSATION_START,
    GET_CONVERSATION_SUCCESS,
    REGISTER_SOCKET_MESSAGE,
    OPERATOR_MESSAGE_SUBMIT,
    RECLASSIFY_START,
    RESET_HISTORICAL_DIALOGUE,
    GET_STATUSES_START,
    GET_STATUSES_SUCCESS,
    GET_STATUSES_FAIL,
    GET_INTENT_ENTITY_MAP_START,
    GET_INTENT_ENTITY_MAP_SUCCESS,
    // GET_INTENT_ENTITY_MAP_FAIL,
    // GET_MESSAGES_HISTORY_SUCCESS,
    GET_DIALOGUE_GENERAL_INFO_START,
    GET_DIALOGUE_GENERAL_INFO_SUCCESS,
    GET_TAB_COUNT_SUCCESS,
    GET_ADF_START,
    GET_ADF_SUCCESS,
    GET_SETTINGS_SUCCESS,
    GET_STOPBOTEVENTS_SUCCESS,
} from './constants'

import socketMessageHandler from './socketHandler'
import submittedMessageHandler from './submittedMessageHandler'

const fixVehicleName = dialogue => {
    if (
        dialogue
        && dialogue[0]
        && dialogue[0].InventoryResponse
        && (!dialogue[0].Vehicle || dialogue[0].Vehicle === '-')
    ) {
        let parsedInventoryResponse
        try {
            parsedInventoryResponse = JSON.parse(dialogue[0].InventoryResponse)
        } catch (e) {
            console.log('FAILED TO PARSE Inventory Response:', e)
            return dialogue
        }
        if (
            parsedInventoryResponse
            && parsedInventoryResponse.inventory_data
            && parsedInventoryResponse.inventory_data.Available
        ) {
            const resultDialogue = JSON.parse(JSON.stringify(dialogue))
            resultDialogue[0].Vehicle = parsedInventoryResponse.inventory_data.Year
                + ' '
                + parsedInventoryResponse.inventory_data.Make
                + ' '
                + parsedInventoryResponse.inventory_data.Model

            return resultDialogue
        }
    }
    return dialogue
}

export default (state = { loadingIntentEntityMap: true }, action) => {
    let newState

    switch (action.type) {
        case GET_INBOX_START:
            {
                const { payload } = action
                const { accumulate, type, refresh } = payload

                newState = {
                    ...state,
                    type,
                    loadingInbox: true,
                }

                if (!accumulate) {
                    newState.inboxData = {}
                    if (!refresh) newState.historicalDialogue = null
                }
            }
            break
        case GET_INBOX_SUCCESS:
            {
                const { payload } = action

                const { inboxNewData, accumulate } = payload

                let { inboxData } = state

                if (inboxData && inboxData.threads && accumulate) {
                    inboxData.threads = [
                        ...inboxData.threads,
                        ...inboxNewData.threads,
                    ]

                    inboxData.lastKey = inboxNewData.lastKey
                } else {
                    inboxData = inboxNewData
                }

                // if (fromTestPage) {
                //     inboxData.threads = inboxData.threads.filter(
                //         data =>
                //             data.fromTestPage === true &&
                //             !data.user?.includes('sierra-sam')
                //     )
                // }

                newState = {
                    ...state,
                    loadingInbox: false,
                    inboxData,
                }
            }
            break
        case GET_INBOX_FAIL:
            newState = {
                ...state,
                loadingInbox: false,
                inboxMessages: [],
            }
            break
        case GET_STATUSES_START:
            newState = {
                ...state,
                loadingStatuses: true,
            }
            break
        case GET_STATUSES_SUCCESS:
            {
                const { payload } = action

                newState = {
                    ...state,
                    loadingStatuses: false,
                    statuses: payload,
                }
            }
            break
        case GET_STATUSES_FAIL:
            newState = {
                ...state,
                loadingStatuses: false,
                statuses: [],
            }
            console.log('FAILED FETCHING STATUSES')
            break
        case GET_CONVERSATION_START:
            newState = {
                ...state,
                historicalDialogue: [],
                historicalDialogueLoading: true,
            }
            break
        case GET_CONVERSATION_SUCCESS:
            {
                const { payload } = action
                const historicalDialogue = fixVehicleName(payload.dialogue)
                const { statusOn } = payload
                const inputForm = payload.input_form
                // let crmStatus
                // if (statusOn) {
                const { crmStatus } = payload
                // }
                // console.log('[reducer historicalDialogue]:', historicalDialogue)

                newState = {
                    ...state,
                    historicalDialogue,
                    historicalDialogueLoading: false,
                    statusOn,
                    crmStatus,
                    inputForm,
                }
            }
            break
        case REGISTER_SOCKET_MESSAGE:
            newState = socketMessageHandler(state, action)
            break
        case OPERATOR_MESSAGE_SUBMIT:
            newState = submittedMessageHandler(state, action)
            break
        case RECLASSIFY_START:
            {
                // const { payload } = action
                // const { botMessage } = payload

                let { historicalDialogue } = state

                // historicalDialogue = historicalDialogue.filter(
                //  element => element.MessageId !== botMessage.MessageId
                // )
                historicalDialogue = historicalDialogue.filter(
                    element => element.MessageStatus !== 'PROCESSING_NOW'
                )

                newState = {
                    ...state,
                    historicalDialogue: [...historicalDialogue],
                }
            }
            break
        case RESET_HISTORICAL_DIALOGUE:
            newState = {
                ...state,
                historicalDialogue: undefined,
            }
            break
        case GET_INTENT_ENTITY_MAP_START:
            newState = {
                ...state,
                loadingIntentEntityMap: true,
            }
            break
        case GET_INTENT_ENTITY_MAP_SUCCESS:
            newState = {
                ...state,
                loadingIntentEntityMap: false,
                intentEntityMap: action.payload,
            }
            break
        case GET_DIALOGUE_GENERAL_INFO_START:
            newState = {
                ...state,
                dialogueGeneralInfo: null,
            }
            break
        case GET_DIALOGUE_GENERAL_INFO_SUCCESS:
            newState = {
                ...state,
                dialogueGeneralInfo: action.payload,
            }
            break
        case GET_ADF_START:
            newState = {
                ...state,
                adf: null,
            }
            break
        case GET_ADF_SUCCESS:
            newState = {
                ...state,
                adf: action.payload,
            }
            break
        case GET_TAB_COUNT_SUCCESS:
            newState = {
                ...state,
                tabCounts: {
                    ...state.tabCounts,
                    [action.payload.type]: action.payload.count,
                },
            }
            break
        case GET_SETTINGS_SUCCESS:
            newState = {
                ...state,
                settings: action.payload,
            }
            break
        case GET_STOPBOTEVENTS_SUCCESS:
            newState = {
                ...state,
                stopBotEvents: action.payload.Items || [],
            }
            break
        default:
            newState = state
            break
    }

    return newState
}
